export const FEATURE_FLAGS = {
  ACCESSIBLE_CABINS: 'bookAccessibleCabins_FF',
  CHOOSE_YOUR_OWN_CABIN: 'bookChooseYourOwnCabin_FF',
  FARE_CLASSES: 'bookFareClasses_FF',
  SERVICE_CHARGE: 'bookServiceCharge_FF',
} as const;

export type FEATURE_FLAGS_VALUE = (typeof FEATURE_FLAGS)[keyof typeof FEATURE_FLAGS];

export type FEATURE_FLAGS_ALL_VALUES = Record<FEATURE_FLAGS_VALUE, boolean>;

export const FEATURE_FLAGS_DEFAULTS: FEATURE_FLAGS_ALL_VALUES = {
  [FEATURE_FLAGS.ACCESSIBLE_CABINS]: false,
  [FEATURE_FLAGS.CHOOSE_YOUR_OWN_CABIN]: false,
  [FEATURE_FLAGS.FARE_CLASSES]: false,
  [FEATURE_FLAGS.SERVICE_CHARGE]: false,
};

export const getFeatureFlagDefault = (flagKey: FEATURE_FLAGS_VALUE) => FEATURE_FLAGS_DEFAULTS[flagKey] ?? false;

export const FEATURE_FLAG_VALUES_RECEIVED = '__featureFlagsReceived';
